import UserMarksTable from './UserMarksTable';

export default UserMarksTable;
